import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { id: "settings" }
const _hoisted_2 = {
  key: 0,
  id: "generalSettings"
}
const _hoisted_3 = { class: "settings-box gen-box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" General settings ")
const _hoisted_5 = { class: "settings-row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Name", -1)
const _hoisted_7 = { class: "settings-row id-box" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "label" }, "ID", -1)
const _hoisted_9 = {
  key: 0,
  class: "settings-row"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Visibility", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_12 = { class: "settings-box clickActions" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "touch_app"),
  /*#__PURE__*/_createTextVNode(" Click Action")
], -1)
const _hoisted_14 = { class: "settings-row" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Add action", -1)
const _hoisted_17 = {
  class: "absoluteMenu",
  ref: "actionAddMenu"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "content_paste", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Paste ")
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "divider"
}
const _hoisted_22 = { class: "material-icons" }
const _hoisted_23 = {
  key: 0,
  id: "actionEditor"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_26 = { class: "settings-box" }
const _hoisted_27 = { class: "material-icons" }
const _hoisted_28 = {
  key: 1,
  class: "settings-box"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("b", { class: "label" }, "no component selected")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_component_list = _resolveComponent("component-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.selection)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h1", null, [
              _createVNode("span", {
                class: "material-icons",
                style: {"cursor":"pointer","user-select":"none"},
                onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.devMode = !_ctx.devMode), ["prevent"]))
              }, _toDisplayString(_ctx.devMode ? "code" : "tune"), 1),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.selection.component.name = $event))
              }, null, 512), [
                [_vModelText, _ctx.selection.component.name]
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("input", {
                type: "text",
                value: _ctx.selection.component.id,
                onInput: _cache[3] || (_cache[3] = $event => (
              !_ctx.devMode
                ? (_ctx.$refs.idInput.value = _ctx.selection.component.id)
                : (_ctx.selection.component.id = _ctx.$refs.idInput.value)
            )),
                ref: "idInput"
              }, null, 40, ["value"]),
              _createVNode("span", {
                class: "material-icons",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.copyID())),
                ref: "copyIcon"
              }, "content_copy", 512)
            ]),
            (_ctx.selection.component.hideable)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("input", {
                    type: "checkbox",
                    checked: _ctx.invisibleIDs.indexOf(_ctx.selection.component.id) == -1,
                    onChange: _cache[5] || (_cache[5] = $event => (_ctx.toggleVis(_ctx.selection.component.id)))
                  }, null, 40, ["checked"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.selection.component.actionable)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_component_list, {
                    root: "",
                    components: _ctx.selection.component.clickAction,
                    modelValue: _ctx.selection.action,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = val => (_ctx.selection.action = val.value)),
                    onDeleted: _ctx.checkDelete,
                    onCopy: _cache[7] || (_cache[7] = val => (_ctx.copiedAction = val)),
                    onAddChild: _ctx.addActionToTree
                  }, null, 8, ["components", "modelValue", "onDeleted", "onAddChild"]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", {
                      class: "btn addAction",
                      onClick: _cache[9] || (_cache[9] = ev => _ctx.showActionAddMenu(ev))
                    }, [
                      _hoisted_15,
                      _hoisted_16,
                      _createVNode("div", _hoisted_17, [
                        (_ctx.copiedAction)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode("div", {
                                class: "entry",
                                onClick: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.pasteAction()), ["stop"]))
                              }, [
                                _hoisted_18,
                                _hoisted_19
                              ]),
                              _hoisted_20
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.actionIDs, (key, index) => {
                          return (_openBlock(), _createBlock("div", { key: index }, [
                            (index != 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_21))
                              : _createCommentVNode("", true),
                            _createVNode("div", {
                              class: "entry",
                              onClick: _withModifiers($event => (_ctx.addNewAction(key)), ["stop"])
                            }, [
                              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.actions[key].icon), 1),
                              _createTextVNode(" " + _toDisplayString(key), 1 /* TEXT */)
                            ], 8, ["onClick"])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512)
                    ])
                  ]),
                  (_ctx.selection && _ctx.selection.action)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _createVNode("h2", null, [
                          _hoisted_24,
                          _createTextVNode(" Edit " + _toDisplayString(_ctx.selection.action.id.toLowerCase()), 1 /* TEXT */)
                        ]),
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.actions[_ctx.selection.action.id].component), {
                          action: 
                _ctx.selection.action.isCheck()
                  ? _ctx.selection.action.check
                  : _ctx.selection.action
              
                        }, null, 8, ["action"]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("", true),
          _hoisted_25,
          _createVNode("div", _hoisted_26, [
            _createVNode("h1", null, [
              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.selection.component.icon), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.selection.component.displayName), 1 /* TEXT */)
            ]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selection.component.vueComponent), {
              component: _ctx.selection.component,
              maxWidth: _ctx.settings.width * 128,
              maxHeight: _ctx.settings.height * 128
            }, null, 8, ["component", "maxWidth", "maxHeight"]))
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_28, [
          _hoisted_29
        ]))
  ]))
}